export default __webpack_public_path__ + "static/media/illustration.20b485ae.svg";